import { useMemo } from 'react';
import { useUi } from '../../store/ui';
import { useNote } from '../../hooks/useVault';

/** Headings of the active note, from the live draft so it tracks typing. */
export function OutlinePanel({ noteId }: { noteId: string | null }) {
  const note = useNote(noteId);
  const raw = useUi((s) => (noteId ? s.drafts[noteId]?.raw : undefined)) ?? note.data?.raw ?? '';
  const headings = useMemo(() => {
    const out: Array<{ depth: number; text: string }> = [];
    let inFence = false;
    for (const line of raw.split('\n')) {
      if (/^\s*```/.test(line)) inFence = !inFence;
      if (inFence) continue;
      const m = /^(#{1,6})\s+(.+?)\s*#*\s*$/.exec(line);
      if (m) out.push({ depth: m[1].length, text: m[2] });
    }
    return out;
  }, [raw]);
  if (!noteId) return <div className="dock-empty">Open a note to see its outline.</div>;
  if (!headings.length) return <div className="dock-empty">No headings.</div>;
  return (
    <div>
      {headings.map((h, i) => (
        <div
          key={i}
          className="bl-item"
          style={{ paddingLeft: 8 + (h.depth - 1) * 12, fontSize: h.depth === 1 ? 13.5 : 12.5, color: h.depth > 2 ? 'var(--text-dim)' : undefined }}
          onClick={() => document.dispatchEvent(new CustomEvent('cortex:goto-heading', { detail: { noteId, heading: h.text } }))}
        >
          {h.text}
        </div>
      ))}
    </div>
  );
}
